import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Client, ClientMaster } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  httpClient: HttpClient;
  constructor(private common: CommonService, private client: HttpClient) { }

  get(id: number): Observable<Client> {

    let url = this.common.getApiAddress();

    url = url + "/clients/" + id

    return this.client.get<Client>(url);

    // return this.client.get<any>(url)
    //   .pipe(
    //     map<any, any>(r => {
    //       return r;
    //     }),
    //     catchError(e => {
    //       return this.common.handleError("Client get failed", e);
    //     })
    //   );
  }

  getAll(name: string): Observable<any> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/clients"
    } else {
      url = url + "/clients?name=" + name;
    }

    return this.client.get(url);

    // return this.client.get<any>(url)
    //   .pipe(
    //     map<any, any>(r => {
    //       return r;
    //     }),
    //     catchError(e => {
    //       return this.common.handleError("Client get failed", e);
    //     })
    //   );
  }

  getAllClientMasters(name: string): Observable<any> {

    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/clientsmaster"
    } else {
      url = url + "/clientsmaster?name=" + name;
    }

    return this.client.get(url);
  }

  create(data: Client): Observable<Client> {
    return this.client.post<Client>(this.common.getApiAddress() + "/clients", data)
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client failed", e);
        })
      );
  }

  createClientMaster(data: ClientMaster): Observable<ClientMaster> {
    return this.client.post<ClientMaster>(this.common.getApiAddress() + "/clientsmaster", data)
      .pipe(
        map<ClientMaster, ClientMaster>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client master failed", e);
        })
      );
  }

  update(data: Client): Observable<Client> {
    return this.client.put<Client>(this.common.getApiAddress() + "/clients/" + data.id.toString(), data)
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Update client failed", e);
        })
      );
  }

  updateClientMaster(data: any): Observable<ClientMaster> {
    return this.client.put<ClientMaster>(this.common.getApiAddress() + "/clientsmaster/" + data.id, data)
      .pipe(
        map<ClientMaster, ClientMaster>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Updating Client master failed", e);
        })
      );
  }

  delete(id:number): Observable<Client> {
    return this.client.delete<Client>(this.common.getApiAddress() + "/clients/" + id.toString())
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete client failed", e);
        })
      );
  }

  deleteClientMaster(id: number): Observable<ClientMaster> {
    return this.client.delete<ClientMaster>(this.common.getApiAddress() + "/clientsmaster/" + id.toString())
      .pipe(
        map<ClientMaster, ClientMaster>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Delete client master failed", e);
        })
      );
  }
}
